(function () {
    'use strict';

    angular.module("imApp").factory("stockHistoricService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3455,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
